<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="visualizar-empreendimento u-margem-superior-pequena">
        <div class="grade__linha grade__linha_alinhar-vertical-centro">
          <span class="grade__coluna">
            <i class="fal fa-home fa-5x"></i>
          </span>

          <div class="grade__coluna grade__coluna_10 informacoes-emprendimento">
            <div class="grade__linha">
              <div class="nome-empreedimento grade__coluna grade__coluna_10">
                <span>{{ empreendimento.Nome }}</span>
              </div>
                <button v-if="true" type="button" @click="redirecionarParaEdicao"
                  class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                  Editar
                </button>

                <button v-if="true" type="button" @click="removerEmpreendimento"
                  class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                  Excluir
                </button>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna">
                <span class="texto">Projeto:
                  <span>{{ empreendimento.ProjetoDeSubsidioNome }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto">Cidade:
                  <span>{{ empreendimento.Cidade.Nome }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto">Tipo de imóvel:
                  <span>{{ empreendimento.TipoDeEmpreendimento }}</span>
                </span>
              </div>

            </div>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <span class="texto">Construtora:
                  <span>{{ empreendimento.Construtora.Nome }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto">CNPJ:
                  <span>{{ empreendimento.Construtora.Cnpj }}</span>
                </span>
              </div>

              <div class="grade__coluna grade__coluna_4">
                <span class="texto">Conta:
                  <span>{{ empreendimento.Construtora.Conta }}</span>
                </span>
              </div>
            </div>

            <div v-if="empreendimento.ProjetoEhBonusMoradia" class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <span class="texto">Total de cotas disponíveis no município:
                  <span>{{ empreendimento.CotasDisponiveisNoMunicipio }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto">Cotas utilizadas no empreendimento:
                  <span>{{ empreendimento.CotasDeImoveisUsadas }}</span>
                </span>
              </div>

              <div class="grade__coluna grade__coluna_4">
                <span class="texto">Cota total disponibilizada no empreendimento:
                  <span>{{ empreendimento.CotaDeImoveis }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';

export default {
  name: 'visualizacao-de-empreendimento',
  components: { Loading, Alerta },
  data() {
    return {
      projetoEhBonusMoradia: null,
      empreendimento: {
        Cidade: {},
        Construtora: {},
      },
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    const idDoEmpreendimento = this.$route.query.idDoEmpreendimento;
    this.exibirCarregamento();
    this.$api.get(`/Empreendimento/${idDoEmpreendimento}`).then((response) => {
      this.esconderCarregamento();
      this.empreendimento = response.data;
      this.ProjetoEhBonusMoradia = response.data.ProjetoEhBonusMoradia;
      return response;
    }).catch((error) => {
      this.tratarErro(error);
    });
  },
  directives: { mask: AwesomeMask },
  methods: {
    removerEmpreendimento() {
      this.exibirCarregamento();
      this.$api.delete(`/Empreendimento/${this.$route.query.idDoEmpreendimento}`).then(() => {
        this.$router.push({ name: 'ListaDeEmpreendimentos' });
      }).catch((error) => {
        this.esconderCarregamento();
        this.tratarErro(error);
      });
    },
    redirecionarParaEdicao() {
      this.$router.push({ name: 'EditarEmpreendimento', query: { idDoEmpreendimento: this.empreendimento.Id }});
    },
    obterNomeDoTipoDoEmpreendimento() {
      const nomesDeTiposDeEmpreendimentos = [];
      nomesDeTiposDeEmpreendimentos[1] = 'Apartamento';
      nomesDeTiposDeEmpreendimentos[2] = 'Casa';
      nomesDeTiposDeEmpreendimentos[3] = 'Casa e apartamento';

      return nomesDeTiposDeEmpreendimentos[this.empreendimento.TipoDeEmpreendimento];
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
    },
  },
};
</script>



// WEBPACK FOOTER //
// VisualizarEmpreendimento.vue?135c8b52